module.exports = __webpack_public_path__ + "images/5fd690edf40c42dded54bfdbd67d6f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/elizabeth_thumb.jpg
// module id = 152
// module chunks = 24